"use client";

import type { ImgHTMLAttributes } from "react";

import { useImageFade } from "./use-image-fade";

/**
 * A plain `<img>` that eases in (opacity 0→1, 700ms) once it loads — for the
 * cases next/image's `fill` doesn't fit: variable-aspect galleries and office
 * thumbnails that render a raw `<img>`. For `fill` next/image use
 * {@link FadeInImage}.
 */
export function FadeImage({
  alt = "",
  className = "",
  ...props
}: ImgHTMLAttributes<HTMLImageElement>) {
  const { loaded, ref, onLoad } = useImageFade();
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      {...props}
      alt={alt}
      ref={ref}
      onLoad={onLoad}
      className={`transition-opacity duration-700 ease-out ${
        loaded ? "opacity-100" : "opacity-0"
      } ${className}`}
    />
  );
}
